export default {
    Pending: { status: 'Wating for Accounts', color: 'yellow-darken-3' },
    Approved: { status: 'Approved By Accounts', color: 'green' },
    Cancel: { status: 'Cancelled By Accounts', color: 'red' },
}